export const MIN_FILE_SIZE_FOR_CHUNK_UPLOAD = 15000000;
export const MIN_UPLOAD_SIZE = 6000000;
